import { DoDont } from '@af/design-system-docs-ui/do-dont';
import { DoDontGrid } from '@af/design-system-docs-ui/do-dont-grid';
import { FeatureBlock } from '@af/design-system-docs-ui/feature-block';
import { FeatureBlockGrid } from '@af/design-system-docs-ui/feature-block-grid';
import { personality } from "../../../../src/pages/rovo-ui/voice-and-tone/_content/_personality";
import * as React from 'react';
export default {
  DoDont,
  DoDontGrid,
  FeatureBlock,
  FeatureBlockGrid,
  personality,
  React
};